import { IThemeCustomization, Theme, Themes } from '../types';
import { getCssVariableBasedOnTheme, themeToCssVariables } from './colors';
import { fontsToCssVariables } from './fonts';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import calendarStylesLight from '../../theme/calendar-styles-light.css';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import calendarStylesDark from '../../theme/calendar-styles-dark.css';

export const appendStyleToShadowRoot = (el: ShadowRoot | HTMLHeadElement, id: string, content: string): boolean => {
  if (!el.querySelector(`style#${id}`)) {
    const styleNode = document.createElement('style');
    styleNode.id = id;
    styleNode.textContent = content;
    el.appendChild(styleNode);
    return true;
  }

  return false;
};

export const generateAndAppendVariableStyles = (
  el: ShadowRoot | HTMLHeadElement,
  dataTheme: Themes,
  themes: IThemeCustomization | undefined,
  withDatePickerStyles?: boolean,
): void => {
  const colorOverwrites = themes?.[dataTheme]?.colors || {};
  const fontOverwrites = themes?.[dataTheme]?.fonts || {};

  // append color css variables
  const themeCssId = `${dataTheme}-theme-variables`;
  const defaultVariables = getCssVariableBasedOnTheme(dataTheme);
  const colorTextContent = themeToCssVariables(defaultVariables, colorOverwrites);
  appendStyleToShadowRoot(el, themeCssId, colorTextContent);

  // append font css variables
  const fontTextContent = fontsToCssVariables(fontOverwrites);
  appendStyleToShadowRoot(el, 'fonts-variables', fontTextContent);

  // append custom calendar styles
  if (withDatePickerStyles) {
    const calendarStyles = dataTheme === Theme.dark ? calendarStylesDark : calendarStylesLight;
    appendStyleToShadowRoot(el, `custom-datepicker-styles-${dataTheme}`, calendarStyles);
  }
};

export const removeOldVariableStyles = (): void => {
  const stylesIds = [
    'client-theme-variables',
    'light-theme-variables',
    'dark-theme-variables',
    'fonts-variables',
    'custom-datepicker-styles-light',
    'custom-datepicker-styles-dark',
  ];

  stylesIds.forEach((id) => {
    const style = document.head.querySelector(`style#${id}`);
    if (style) style.remove();
  });
};
